module.exports = __webpack_public_path__ + "static/media/logo.86bcba50.png";